/* Reminders list cards between Up next and Your dates.

   Favourite flowers and group gifts already fill their own sections.
   This file adds the collapse control on those, and the member's own
   wish-list card: a count or a few hearts when /wishlist/me already
   returns them, and a link back to /pages/wishlist either way. It does
   not load the catalogue or save hearts. The open/closed choice is kept
   in localStorage (fb_rem_cards) for this browser only. */
(function (root, factory) {
  var lib = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = lib;
  else if (root.document) {
    var boot = function () { lib.start(root.document); };
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', boot);
    else boot();
    root.document.addEventListener('shopify:section:load', boot);
  }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var KEY = 'fb_rem_cards';

  function listNames(names, max) {
    max = max || 4;
    var list = (names || []).filter(Boolean);
    if (list.length <= 1) return list[0] || '';
    if (list.length <= max) return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
    return list.slice(0, max - 1).join(', ') + ' and ' + (list.length - (max - 1)) + ' more';
  }

  /* Only a real image URL. Titles are text; this never becomes HTML. */
  function safeImage(src) {
    if (typeof src !== 'string') return '';
    var value = src.trim();
    if (/^https:\/\/[^\s]+$/.test(value)) return value;
    if (/^\/(?!\/)[^\s]*$/.test(value)) return value;
    return '';
  }

  function thumbSrc(src) {
    if (src.indexOf('https://cdn.shopify.com/') !== 0) return src;
    try {
      var url = new URL(src);
      url.searchParams.set('width', '96');
      return url.href;
    } catch (_) { return src; }
  }

  /* The member's own hearts. Names only when every pick already has one,
     so a bare handle is never shown as a product title. */
  function heartSummary(picks) {
    var list = Array.isArray(picks) ? picks.filter(function (pick) {
      return pick && typeof pick === 'object';
    }) : [];
    var names = [];
    var images = [];
    list.forEach(function (pick) {
      var title = typeof pick.title === 'string' ? pick.title.trim() : (typeof pick.name === 'string' ? pick.name.trim() : '');
      if (title) names.push(title);
      var image = safeImage(typeof pick.image === 'string' ? pick.image : '');
      if (image) images.push(image);
    });
    var count = list.length;
    if (!count) return { count: 0, line: '', images: [] };
    if (names.length === count) return { count: count, line: listNames(names, 4), images: images.slice(0, 4) };
    return { count: count, line: count === 1 ? '1 hearted' : String(count) + ' hearted', images: [] };
  }

  function storedOpen(data, id) {
    if (!data || typeof data !== 'object' || Array.isArray(data)) return true;
    if (!Object.prototype.hasOwnProperty.call(data, id)) return true;
    return data[id] !== 0 && data[id] !== false;
  }

  function readMap(storage) {
    try {
      var store = storage || root.localStorage;
      if (!store) return {};
      var data = JSON.parse(store.getItem(KEY) || '{}');
      if (!data || typeof data !== 'object' || Array.isArray(data)) return {};
      return data;
    } catch (_) { return {}; }
  }

  function writeOpen(storage, id, open) {
    if (!id) return;
    try {
      var store = storage || root.localStorage;
      if (!store) return;
      var data = readMap(store);
      data[id] = open ? 1 : 0;
      store.setItem(KEY, JSON.stringify(data));
    } catch (_) {}
  }

  function el(doc, tag, className, text) {
    var node = doc.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function glyph(doc, kind) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = doc.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'fb-reminders-card__icon fb-reminders-card__icon--' + kind);
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '22');
    svg.setAttribute('height', '22');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = doc.createElementNS(ns, 'path');
    path.setAttribute('d', kind === 'min' ? 'M6 15l6-6 6 6' : 'M6 9l6 6 6-6');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2');
    svg.appendChild(path);
    return svg;
  }

  function directChild(card, className) {
    var kids = card.children;
    if (!kids) return null;
    for (var i = 0; i < kids.length; i += 1) {
      if (kids[i].classList && kids[i].classList.contains(className)) return kids[i];
    }
    return null;
  }

  function setOpen(card, open) {
    card.classList.toggle('is-collapsed', !open);
    var button = card.querySelector('[data-fb-collapse-toggle]');
    if (!button) return;
    var label = open ? 'Minimise' : 'Maximise';
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
  }

  function arm(card) {
    var heading = card.querySelector('h2');
    if (!heading) return;
    var doc = card.ownerDocument;
    var head = directChild(card, 'fb-reminders-card__head');
    if (!head) {
      head = el(doc, 'div', 'fb-reminders-card__head');
      if (heading.parentNode) heading.parentNode.insertBefore(head, heading);
      else card.appendChild(head);
    }
    if (heading.parentNode !== head) head.insertBefore(heading, head.firstChild);
    var button = head.querySelector('[data-fb-collapse-toggle]');
    if (!button) {
      button = el(doc, 'button', 'fb-reminders-card__toggle');
      button.type = 'button';
      button.setAttribute('data-fb-collapse-toggle', '');
      button.appendChild(glyph(doc, 'min'));
      button.appendChild(glyph(doc, 'max'));
      head.appendChild(button);
    }
    if (!button.__fbToggle) {
      button.__fbToggle = true;
      button.addEventListener('click', function () {
        var open = card.classList.contains('is-collapsed');
        setOpen(card, open);
        writeOpen(null, card.getAttribute('data-fb-collapse'), open);
      });
    }
    var body = directChild(card, 'fb-reminders-card__body');
    if (!body) {
      body = el(doc, 'div', 'fb-reminders-card__body');
      card.appendChild(body);
    }
    var id = card.getAttribute('data-fb-collapse') || 'card';
    if (!body.id) body.id = 'fb-reminders-card-' + id;
    button.setAttribute('aria-controls', body.id);
    var stray = [];
    Array.prototype.forEach.call(card.children, function (child) {
      if (child !== head && child !== body) stray.push(child);
    });
    stray.forEach(function (child) { body.appendChild(child); });
    setOpen(card, storedOpen(readMap(), id));
  }

  function watch(card) {
    if (card.__fbCards) return;
    card.__fbCards = true;
    var working = false;
    if (typeof root.MutationObserver === 'function') {
      var observer = new root.MutationObserver(function () {
        if (working) return;
        working = true;
        try { arm(card); } finally { working = false; }
      });
      observer.observe(card, { childList: true });
    }
    arm(card);
  }

  function wishlistHref(card) {
    var link = card.querySelector('a[href]');
    var href = link && link.getAttribute('href');
    if (typeof href === 'string' && /^\/(?!\/)\S*$/.test(href)) {
      if (/[?&]via=reminders(?:-|&|$)/.test(href)) return href;
      return href + (href.indexOf('?') === -1 ? '?' : '&') + 'via=reminders-list';
    }
    return '/pages/wishlist?via=reminders-list';
  }

  function heartLink(doc, href, className) {
    var link = el(doc, 'a', className, 'View');
    link.href = href;
    link.setAttribute('aria-label', 'View wish list');
    return link;
  }

  function paintWishlist(body, summary, href, api) {
    var doc = body.ownerDocument;
    body.textContent = '';
    if (!summary.count) {
      var prompt = el(doc, 'div', 'fbf-summary__prompt');
      prompt.appendChild(el(doc, 'p', null, 'Nothing hearted yet.'));
      prompt.appendChild(heartLink(doc, href, 'fbf-summary__more'));
      body.appendChild(prompt);
      appendRequestAction(body, api);
      return;
    }
    var list = el(doc, 'ul', 'fbf-summary__list');
    list.setAttribute('role', 'list');
    var row = el(doc, 'li', 'fbf-summary__row');
    if (summary.images.length) {
      var thumbs = el(doc, 'span', 'fbf-summary__thumbs');
      thumbs.setAttribute('aria-hidden', 'true');
      summary.images.forEach(function (src) {
        var img = el(doc, 'img', 'fbf-summary__thumb');
        img.alt = '';
        img.src = thumbSrc(src);
        thumbs.appendChild(img);
      });
      row.appendChild(thumbs);
    }
    var text = el(doc, 'span', 'fbf-summary__text');
    text.appendChild(el(doc, 'strong', null, 'You'));
    text.appendChild(el(doc, 'span', null, summary.line));
    row.appendChild(text);
    row.appendChild(heartLink(doc, href, 'fbf-summary__edit'));
    list.appendChild(row);
    body.appendChild(list);
    appendRequestAction(body, api);
  }

  function requestWishList(api, friendId) {
    return api.createRecipientRequest(friendId, { picks: true, address: false, birthday: false });
  }

  function appendRequestAction(body, api) {
    var doc = body.ownerDocument;
    var ask = el(doc, 'a', 'fb-reminders-card__primary', 'Ask for a wish list →');
    ask.href = '/pages/wishlist-rewards';
    body.appendChild(ask);
  }

  async function openWishlistRequest(doc, api, opener) {
    var dialog = el(doc, 'dialog', 'fb-reminders-card-dialog ph-no-capture');
    var title = el(doc, 'h2', null, 'Ask for a wish list');
    title.id = 'fb-wishlist-request-title';
    dialog.setAttribute('aria-labelledby', title.id);
    var close = el(doc, 'button', 'fb-reminders-card-dialog__close', '×');
    close.type = 'button'; close.setAttribute('aria-label', 'Close request');
    close.addEventListener('click', function () { dialog.close(); });
    dialog.appendChild(close); dialog.appendChild(title);
    dialog.appendChild(el(doc, 'p', null, 'Choose someone, then send them a link to tell you what they’d love.'));
    var status = el(doc, 'p', null, 'Loading your people…');
    status.setAttribute('role', 'status'); dialog.appendChild(status);
    doc.body.appendChild(dialog);
    var reset = function () { if (dialog.open) dialog.close(); };
    doc.addEventListener('fb-reminders:verified', reset);
    dialog.addEventListener('close', function () { doc.removeEventListener('fb-reminders:verified', reset); dialog.remove(); if (opener.isConnected) opener.focus(); });
    dialog.showModal();
    try {
      var response = await api.getOccasions();
      if (!dialog.open) return;
      var seen = {};
      var people = (response.occasions || []).filter(function (item) {
        if (!item.friendId || seen[item.friendId]) return false;
        seen[item.friendId] = true; return true;
      });
      status.textContent = '';
      if (!people.length) {
        status.textContent = 'Add someone to your reminders first.';
        var add = el(doc, 'button', 'fb-reminders-card__primary', 'Add a reminder');
        add.type = 'button'; add.setAttribute('data-fb-reminders-open', ''); add.setAttribute('data-reminders-open-state', 'capture');
        add.addEventListener('click', function () { dialog.close(); }); dialog.appendChild(add); return;
      }
      var form = el(doc, 'form');
      var label = el(doc, 'label', null, 'Who would you like to ask?');
      label.htmlFor = 'fb-wishlist-request-person';
      var select = el(doc, 'select'); select.id = label.htmlFor;
      people.forEach(function (item) { var option = el(doc, 'option', null, item.name); option.value = item.friendId; select.appendChild(option); });
      form.appendChild(label); form.appendChild(select);
      var create = el(doc, 'button', 'fb-reminders-card__primary', 'Create request link'); create.type = 'submit'; form.appendChild(create);
      dialog.appendChild(form);
      var sharing = el(doc, 'div'); sharing.hidden = true;
      var inputLabel = el(doc, 'label', null, 'Request link'); inputLabel.htmlFor = 'fb-wishlist-request-link';
      var input = el(doc, 'input'); input.id = inputLabel.htmlFor; input.type = 'url'; input.readOnly = true;
      var copy = el(doc, 'button', 'fb-reminders-card__primary', 'Copy request link'); copy.type = 'button';
      copy.addEventListener('click', async function () {
        input.focus(); input.select();
        try { await root.navigator.clipboard.writeText(input.value); status.textContent = 'Link copied. Send it to them whenever you’re ready.'; }
        catch (_) { status.textContent = 'Select and copy the link above, then send it to them.'; }
      });
      sharing.appendChild(inputLabel); sharing.appendChild(input); sharing.appendChild(copy); dialog.appendChild(sharing);
      select.addEventListener('change', function () { sharing.hidden = true; input.value = ''; status.textContent = ''; });
      form.addEventListener('submit', async function (event) {
        event.preventDefault(); if (create.disabled) return;
        create.disabled = true; select.disabled = true; sharing.hidden = true; status.textContent = 'Creating your link…';
        try {
          var request = await requestWishList(api, select.value);
          if (!dialog.open) return;
          input.value = request.url; sharing.hidden = false;
          status.textContent = 'Send this link to ' + select.options[select.selectedIndex].text + '. Their picks will appear on their reminders page.';
          input.focus(); input.select();
        } catch (error) { status.textContent = error.message || 'We couldn’t make the link. Try again.'; }
        finally { create.disabled = false; select.disabled = false; }
      });
      select.focus();
    } catch (error) { status.textContent = error.message || 'We couldn’t load your people. Close this panel and try again.'; }
  }

  // The Reminders list waits for this on desktop (assets/fb-reminders.js).
  function settle(card) { card.removeAttribute('data-fb-card-pending'); }

  function fillWishlist(card) {
    var body = card.querySelector('[data-fb-wishlist-body]');
    if (!body || !root.FBRemindersAPI || typeof root.FBRemindersAPI.create !== 'function') return settle(card);
    var base = card.getAttribute('data-api-base') || '';
    if (!base) return settle(card);
    var href = wishlistHref(card);
    var api;
    try { api = root.FBRemindersAPI.create(base); } catch (_) { return settle(card); }
    api.request('/wishlist/me').then(function (response) {
      var list = response && response.list;
      if (!list) {
        paintWishlist(body, heartSummary([]), href, api);
        return;
      }
      paintWishlist(body, heartSummary(list.picks), href, api);
    }).catch(function () {}).then(function () { settle(card); });
  }

  function start(doc) {
    if (!doc || !doc.querySelectorAll) return;
    Array.prototype.forEach.call(doc.querySelectorAll('[data-fb-collapse]'), watch);
    var wish = doc.querySelector('[data-fb-wishlist-card]');
    if (wish) fillWishlist(wish);
  }

  return {
    KEY: KEY,
    listNames: listNames,
    safeImage: safeImage,
    thumbSrc: thumbSrc,
    heartSummary: heartSummary,
    storedOpen: storedOpen,
    readMap: readMap,
    writeOpen: writeOpen,
    start: start,
    requestWishList: requestWishList,
    paintWishlist: paintWishlist
  };
});
